/* eslint-disable @typescript-eslint/no-explicit-any, react-hooks/rules-of-hooks*/

import { ConnectForm, ControlledComponentProps } from "@/components/Controlled"
import { SelectWithButtons, SelectWithButtonsProps } from "@/components/SelectWithButtons/SelectWithButtons"
import React from "react"
import { useController } from "react-hook-form"

export const SelectWithButtonsInput = ({
    label,
    name,
    defaultValue,
    options,
    ...props
}: ControlledComponentProps<SelectWithButtonsProps>) => (
    <ConnectForm>
        {({ control }) => {
            const { field } = useController({ name, control, defaultValue })
            const onChange = (value: number) => {
                props.onChange(value)
                field.onChange(value)
            }
            return (
                <SelectWithButtons
                    {...props}
                    {...field}
                    label={label}
                    value={field.value}
                    onChange={onChange}
                    options={options}
                />
            )
        }}
    </ConnectForm>
)
